var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingplanicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 16V4C2.5 3.46957 2.71071 2.96086 3.08579 2.58579C3.46086 2.21071 3.96957 2 4.5 2H15.5",
    stroke: "#0773EA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 14H4.5C3.96957 14 3.46086 14.2107 3.08579 14.5858C2.71071 14.9609 2.5 15.4696 2.5 16C2.5 16.5304 2.71071 17.0391 3.08579 17.4142C3.46086 17.7893 3.96957 18 4.5 18H5.5",
    stroke: "#0773EA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 18H11.5C10.9696 18 10.4609 18.2107 10.0858 18.5858C9.71071 18.9609 9.5 19.4696 9.5 20M9.5 20C9.5 20.5304 9.71071 21.0391 10.0858 21.4142C10.4609 21.7893 10.9696 22 11.5 22H22.5V6H11.5C10.9696 6 10.4609 6.21071 10.0858 6.58579C9.71071 6.96086 9.5 7.46957 9.5 8V20Z",
    stroke: "#0773EA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingplanicon);
export default __webpack_public_path__ + "static/media/trainingplanicon.a0f0ba71ddb764b5226ee5c07f522384.svg";
export { ForwardRef as ReactComponent };